import IntradayChart from '../../modules/StockChartSp/IntradayChart.vue';
import HistoricalChart from '../../modules/StockChartSp/HistoricalChart.vue';
import PeriodLabel from '../../modules/StockChartSp/PeriodLabel.vue';

/*
 * 個別銘柄トップのチャート
 * @vue-components {IntradayChart} IntradayChart 日中足チャート
 * @vue-components {HistoricalChart} HistoricalChart 履歴チャート
 * @vue-components {PeriodLabel} PeriodLabel 期間選択ラベル
 */
const StockTopChartSp = {
  el: '#v-stock-top-chart-sp',
  components: {
    IntradayChart,
    HistoricalChart,
    PeriodLabel,
  },
  computed: {
    /**
     * 日中足チャートであれば真
     * @return {boolean}
     */
    isIntradayChart() {
      return this.$store.getters['chartTerm'] === 'today';
    },
    /**
     * 履歴チャートであれば真
     * @return {boolean}
     */
    isHistoricalChart() {
      return this.$store.getters['chartTerm'] !== 'today';
    },
  },
};

export default StockTopChartSp;
